/**
 * The tags a phrase body may carry. No attributes at all: a body is clinician-authored HTML that
 * gets rendered back into a note, so nothing that could hold a URL or an event handler is kept.
 */
export const DOT_PHRASE_ALLOWED_BODY_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "del",
  "ul",
  "ol",
  "li",
];
